const singleLetterWordPattern = /^[^\p{L}\p{N}]*\p{L}$/u

export function glueSingleLetterWords(text: string): string {
  const words = text.split(' ')
  return words.reduce((result, word, index) => {
    if (index === 0) {
      return word
    }
    const separator = singleLetterWordPattern.test(words[index - 1]) ? ' ' : ' '
    return `${result}${separator}${word}`
  }, '')
}
